module.exports = __webpack_public_path__ + "static/media/co10.1a9b5081.png";